/* global _hsq */

class HubspotAdapter {
  /**
   * Track internal users on Hubspot
   * ONLY AVAILABLE TO MARKETING HUB ENTERPRISE
   * @param {String} title - Description of the event
   * @param {Object} event - Data to track
   * @see https://knowledge.hubspot.com/analytics-tools/create-custom-behavioral-events
   */
  static track(title, event) {
    if (typeof _hsq !== 'undefined') {
      _hsq.push([
        'trackCustomBehavioralEvent',
        {
          name: title,
          properties: {
            ...event,
          },
        },
      ]);
    }
  }

  /**
   * Hubspot Identify
   * identify will not actually be passed to Hubspot with this call and the user properties
   * will only be passed when tracking a page view or an event
   * @see https://developers.hubspot.com/docs/api/events/tracking-code
   */
  static identify(userProperties) {
    if (typeof _hsq !== 'undefined') {
      // eslint-disable-next-line camelcase
      const { uid, ...up } = userProperties;
      _hsq.push([
        'identify',
        {
          ...up,
          id: uid,
        },
      ]);
    }
  }
}

export default HubspotAdapter;
